<template>
  <div class="c-pb-element-bar">
    <div class="c-pb-element-bar__actions">
      <base-tooltip follow-cursor text="Move">
        <a
          class="c-pb-element-bar__action"
          @click.prevent="$emit('clickMove')"
          href="#"
        >
          <icon width="18" height="18" name="move"></icon>
        </a>
      </base-tooltip>
    </div>
    <div class="c-pb-element-bar__actions">
      <base-tooltip follow-cursor text="Edit">
        <a
          class="c-pb-element-bar__action"
          @click.prevent="$emit('clickEdit')"
          href="#"
        >
          <icon width="18" height="18" name="edit"></icon>
        </a>
      </base-tooltip>
      <base-tooltip follow-cursor text="Duplicate">
        <a
          class="c-pb-element-bar__action"
          @click.prevent="$emit('clickDuplicate')"
          href="#"
        >
          <icon width="18" height="18" name="duplicate"></icon>
        </a>
      </base-tooltip>
      <base-tooltip follow-cursor text="Delete">
        <a
          class="c-pb-element-bar__action"
          @click.prevent="$emit('clickDelete')"
          href="#"
        >
          <icon width="18" height="18" name="delete"></icon>
        </a>
      </base-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "pb-element-bar",
};
</script>

<style lang="scss">
.c-pb-element-bar {
  height: 56px;
  background: rgba(66, 85, 99, 0.9);

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  display: none;

  &__actions {
    display: flex;
  }

  &__action {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    width: 56px;
    font-size: 12px;
    border-right: 1px solid rgba(0, 0, 0, 0.25);
    color: $colour-nhs-white;
  }
}
</style>
